import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { gsap } from 'gsap'
import { signal } from 'services/SignalsService'
import { reelsSettings, spinSettings } from 'settings/custom/reels'
import { Device } from 'utils/Device'
import { create } from 'utils/Object'

const { expanding } = reelsSettings
const { chance, respin } = spinSettings

export default class OverReelAnimation extends Container {
  constructor(data) {
    super()
    this._data = data
    this._isDesktop = Device.isDesktop()
    this.reel = parseFloat(data.name.match(/\d+/))
    this.animation = {
      wild: '',
      scatter: '',
      spin: '',
    }
    this.interactive = true
    if (expanding) {
      this.make.call(this, 'wild', expanding)
    }

    if(chance){
      this.make.call(this, 'scatter', chance)
    }

    if (respin){
      this.make.call(this, 'spin', respin)
    }
  }

  make(name, value) {
    this.animation[name] = new Spine(create(this._data, value))
    this.animation[name].scale.set(this._isDesktop ? 1 : 0.5)
    this.animation[name].visible = false
    this.animation[name].x += value.x || 0
    this.animation[name].y += value.y || 0
    this.animation[name].scaleX += value.scaleX || 0
    this.animation[name].scaleY += value.scaleY || 0
    this.addChild(this.animation[name])
  }

  async begin(name, coord) {
    if (this.animation[name]){
      if (name === 'wild'){
        const list = ['up', 'mid', 'down']
        const [, y] = coord

        signal.dispatch('SOUND:WILD-BEGIN')

        this.animation.wild.visible = true
        this.animation.wild.playCallBack(list[y], false, () => {
          this.animation.wild.setToSetupPose()
          this.animation.wild.playCallBack('loop', true, () => {}, false)
        }, false)
        setTimeout(() => {
          signal.dispatch(`EXPANDED-${this.reel}`)
        }, 2000)

      }
      else {
        this.delayTween =  gsap.delayedCall(spinSettings.delayStart * this.reel,  () => {
          this.animation[name].play(name)
          this.animation[name].visible = true
        })

      }
    }
  }

  end(name) {
    if (this.animation[name]){
      this.animation[name].visible = false
      this.animation[name].stop()
    }
  }
}
